import React, {FC} from "react";
import styled from "styled-components";

const Link = styled.a`
	font-weight: 700;
`;

export const TextLink: FC<
	Omit<
		React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>,
		"ref"
	>
> = (props) => {
	return (
		<Link href={props.href} {...props}>
			{props.children}
		</Link>
	);
};
